var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "form-wrapper" }, [
    _c(
      "div",
      { staticClass: "confirmation" },
      [
        _c("card-header", {
          attrs: {
            title: "Start a free 14-day trial",
            designVersion: 2,
            subtitle: "No credit card required",
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "body" },
          [
            _c(
              "div",
              { staticClass: "spinner", class: { hidden: !_vm.isSubmitting } },
              [_c("i", { staticClass: "fa fa-spinner fa-pulse" })]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "form-group",
                class: { hidden: _vm.isSubmitting },
              },
              [
                _c("input-set", {
                  ref: "email",
                  attrs: {
                    type: "text",
                    name: "email",
                    label: _vm.errors.email ? _vm.errors.email : "",
                    placeholder: "Work email*",
                    hasError: _vm.errors.email ? true : false,
                  },
                  on: {
                    inputOnEnter: _vm.signUp,
                    inputOnBlur: _vm.checkOnInputBlur,
                    inputOnType: _vm.checkOnInputType,
                  },
                  model: {
                    value: _vm.email,
                    callback: function ($$v) {
                      _vm.email = $$v
                    },
                    expression: "email",
                  },
                }),
                _vm._v(" "),
                _c("password-input-with-suggestion", {
                  attrs: {
                    inputLabel: "",
                    wrapperClass: "input-set",
                    inputClass: "form-control",
                    inputName: "password",
                    inputPlaceholder: "Password*",
                    checkErrors: true,
                    tabindex: 2,
                  },
                  on: {
                    onPasswordChange: _vm.onPasswordChange,
                    onPasswordValidation: _vm.onPasswordValidation,
                    passwordOnEnter: _vm.signUp,
                    confirm: _vm.signUp,
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "button-wrapper" },
                  [
                    !_vm.isSubmitting
                      ? _c("custom-button", {
                          attrs: {
                            text: "Sign up",
                            isActive: _vm.buttonState,
                            size: "button-large",
                          },
                          on: { enter: _vm.signUp, click: _vm.signUp },
                        })
                      : _c(
                          "button",
                          {
                            staticClass: "btn btn-primary hidden",
                            attrs: {
                              id: "mock-button-to-maintain-form-height",
                              isActive: false,
                            },
                          },
                          [_vm._v("Sign up")]
                        ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c(
                  "paragraph",
                  {
                    attrs: { id: "agree-text", type: "p", variation: "small" },
                  },
                  [
                    _vm._v(
                      "\n                    By clicking Sign up, I agree to Autobahn's "
                    ),
                    _c(
                      "a",
                      {
                        attrs: {
                          tabindex: "1",
                          href: "/terms",
                          target: "_blank",
                        },
                      },
                      [_vm._v("Terms of Use")]
                    ),
                    _vm._v(" and the "),
                    _c(
                      "a",
                      {
                        attrs: {
                          tabindex: "1",
                          href: "/privacy",
                          target: "_blank",
                        },
                      },
                      [_vm._v("Privacy Policy")]
                    ),
                    _vm._v(".\n                "),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "paragraph",
              {
                class: { hidden: _vm.isSubmitting },
                attrs: {
                  id: "already-registered-text",
                  type: "p",
                  variation: "medium",
                },
              },
              [
                _vm._v("\n                Already have an account? "),
                _c("a", { attrs: { tabindex: "1", href: "/login" } }, [
                  _vm._v("Log in"),
                ]),
              ]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }